import { Text } from '@/components/atoms/text';

export const EmptyRichResponse = ({ message }: { message: string }) => {
  return (
    <Text
      variant='body-m'
      classNames={{ wrapper: 'font-mono text-left px-2 py-4' }}
      color='neutral-dark-N50'
    >
      {message}
    </Text>
  );
};
